import { render, staticRenderFns } from "./HospitalReservation.vue?vue&type=template&id=2320ead6&"
import script from "./HospitalReservation.vue?vue&type=script&lang=ts&"
export * from "./HospitalReservation.vue?vue&type=script&lang=ts&"
import style0 from "./HospitalReservation.vue?vue&type=style&index=0&id=2320ead6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports